import React from "react"
import { createIcon } from "@chakra-ui/icons"

const SlashedShieldIcon = createIcon({
  displayName: "SlashedShieldIcon",
  viewBox: "0 0 640 512",
  path: (
    <path d="M174.2 111.2L320 49.4 503 127c5.9 2.5 9.1 7.8 9 12.8c-.3 52.8-13 127.8-52.2 195.3L174.2 111.2zM497.9 365c47.4-78.8 61.8-166.3 62.1-225c.1-26.2-16.3-47.9-38.3-57.2L333.4 2.9C329.2 1 324.7 0 320 0s-9.2 1-13.4 2.9L131 77.4 38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L497.9 365zM80.6 159.5c5.5 102 51.5 266.3 213.1 343.7c16.7 8 36.1 8 52.8 0c35.7-17.1 65.8-38.5 91.1-62.5l-38.2-30.1c-20.8 18.9-45.1 35.7-73.5 49.3c-3.6 1.7-7.8 1.7-11.3 0C195.8 403.1 147.9 290.6 133.3 201L80.6 159.5z" />
  ),
})

export default SlashedShieldIcon
